var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-card", { staticClass: "small-vehicle-card" }, [
    _c(
      "div",
      { staticClass: "card-img-wrapper d-flex justify-content-center" },
      [
        _c("vehicle-image", {
          staticClass: "card-img",
          attrs: {
            "body-style": _vm.vehicle.bodyType,
            "vehicle-name": _vm.vehicleName,
            "vehicle-image-url": _vm.vehicleImageUrl
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-flex flex-column justify-content-sm-end justify-content-between h-100 w-100"
      },
      [
        _c("h5", { staticClass: "d-sm-none" }, [
          _c("span", { staticClass: "yearMake" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.vehicle.year) +
                " " +
                _vm._s(_vm.vehicle.make) +
                " "
            )
          ]),
          _c("br"),
          _vm._v(
            "\n            " +
              _vm._s(_vm.vehicle.model) +
              " " +
              _vm._s(_vm.vehicle.trim) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("h5", { staticClass: "d-sm-block d-none text-center" }, [
          _c("span", { staticClass: "yearMakeModel" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.vehicle.year) +
                " " +
                _vm._s(_vm.vehicle.make) +
                "\n                " +
                _vm._s(_vm.vehicle.model) +
                " "
            )
          ]),
          _c("br"),
          _vm._v("\n            " + _vm._s(_vm.vehicle.trim) + "\n        ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between d-sm-none price-blocks flex-wrap"
          },
          [
            _c("price-block", {
              attrs: { label: "Base Price", value: _vm.vehicle.msrp }
            }),
            _vm._v(" "),
            _c("price-block", {
              attrs: {
                label: "Options",
                value: _vm.optionsCost,
                "add-plus": ""
              }
            }),
            _vm._v(" "),
            _c("price-block", {
              attrs: {
                label: "Total",
                value: _vm.vehicle.msrp + _vm.optionsCost,
                variant: "blue"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }